export function isE2ETestEnv() {
  return Boolean(typeof navigator !== 'undefined' && navigator.webdriver);
}
